export const USER_STATUS = {
    ACTIVE: 1,
    DELETED: 2,
    BLOCKED: 3
};
